import { useState } from "react";
import { requestHelper } from "../helpers/request-helper";

export function useLogisticPrice() {
  let [data, setData] = useState<number>();
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState(null);

  function retrieve() {
    setLoading(true);
    setError(null);
    return requestHelper(
      `
        query proxyLogisticPrice {
            proxyLogisticPrice
          }
        `
    )
      .then((data) => {
        setData(data.proxyLogisticPrice);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { retrieve, data, loading, error };
}
